export default {
  MARITAL_STATUS_REPOSITORY: Symbol.for('MARITAL_STATUS_REPOSITORY'),
  MARITAL_STATUS_STATE_MANAGER: Symbol.for('MARITAL_STATUS_STATE_MANAGER'),
  GET_MARITAL_STATUSES_QUERY: Symbol.for('GET_MARITAL_STATUSES_QUERY'),
};
